import { __assign, __awaiter, __generator, __rest } from "tslib";
/* eslint-disable camelcase */
import { LINK_PREVIEW_TYPE } from 'wix-rich-content-common';
import { fetchOembed } from '../fetchOembed';
var providerBlackList = ['wix', 'facebook'];
export default function linkPreviewStrategy(instance) {
    var _a;
    var _this = this;
    if (!instance)
        return {};
    var fetchData = function (url) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                return [2 /*return*/, fetchOembed(url, instance).then(function (json) {
                        var html = json.html, rest = __rest(json, ["html"]);
                        var provider_name = rest.provider_name;
                        var res = providerBlackList.includes((provider_name || '').toLowerCase())
                            ? __assign({}, rest) : __assign(__assign({}, rest), { html: html });
                        return res;
                    })];
            }
            catch (e) {
                return [2 /*return*/, new Promise(function (resolve) {
                        setTimeout(function () { return resolve({}); }, 1);
                    })];
            }
            return [2 /*return*/];
        });
    }); };
    return {
        config: (_a = {},
            _a[LINK_PREVIEW_TYPE] = {
                fetchData: fetchData,
            },
            _a),
    };
}
//# sourceMappingURL=linkPreviewStrategy.js.map